"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "brands", {
    enumerable: true,
    get: function() {
        return brands;
    }
});
const brands = [
    {
        id: "raw",
        name: "Raw",
        color: "#fff",
        balance: 30000000,
        backgroundColor: "#941b27",
        directorId: "adam-pearce",
        company: "WWE",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2022/06/RAW-Logo--7d5dc4d69611241d54973979bdae1d32.png"
    },
    {
        id: "smackdown",
        name: "Smackdown",
        color: "#fff",
        backgroundColor: "#1b5087",
        directorId: "nick-aldis",
        company: "WWE",
        balance: 30000000,
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2019/10/SmackDown_2019_Vert_White--dfb28435b27ecf12e75406176c168c6a.png"
    },
    {
        id: "nxt",
        name: "NXT",
        color: "#fff",
        backgroundColor: "#000",
        directorId: "shawn-michaels",
        company: "WWE",
        balance: 4000000,
        image: "//www.wwe.com/f/styles/wwe_show_logo_sm/public/all/2022/09/NXT_NewLogo--61a7c04575fabf96fb577dcdfc0bde63.png"
    },
    {
        id: "dynamite",
        name: "Dynamite",
        company: "AEW",
        balance: 20000000,
        directorId: "tony-khan",
        backgroundColor: "#181918",
        color: "#f8eabb"
    },
    {
        id: "collision",
        name: "Collision",
        company: "AEW",
        balance: 20000000,
        directorId: "tony-khan",
        backgroundColor: "#181918",
        color: "#f8eabb"
    },
    {
        id: "roh",
        name: "Ring Of Honor",
        company: "AEW",
        color: "#000",
        backgroundColor: "#fff",
        directorId: "tony-khan",
        balance: 2000000
    },
    {
        id: "tna",
        name: "TNA",
        color: "#fff",
        backgroundColor: "#201515",
        company: "MISC",
        balance: 2000000
    },
    {
        id: "wcw",
        name: "WCW",
        directorId: "eric-bischoff",
        company: "TKO",
        color: "#fff",
        backgroundColor: "#242424",
        balance: 60000000,
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/2016/03/WCW--73cd209af37176058f6fbaee821d2bf0.png"
    },
    {
        id: "ecw",
        name: "ECW",
        company: "TKO",
        color: "#fff",
        backgroundColor: "#000",
        directorId: "paul-heyman",
        balance: 500000,
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/2016/03/ECW--618ee2651cb1c769e50855fd47255361.png"
    },
    {
        id: "njpw",
        name: "NJPW",
        company: "MISC",
        color: "#fff",
        backgroundColor: "#000",
        balance: 5000000
    },
    {
        id: "hof",
        name: "Hall of Fame",
        color: "#fff",
        company: "TKO",
        backgroundColor: "#4b5050",
        balance: 1000000,
        image: "//www.wwe.com/f/styles/wwe_show_logo_sm/public/all/2019/03/HallOfFame_2019--2abc07334db4d339fbf4fd06f740fe53.png"
    },
    {
        id: "ufc",
        name: "UFC",
        company: "TKO",
        color: "#000",
        backgroundColor: "#fff",
        balance: 1000000
    }
];
